// extracted by mini-css-extract-plugin
export default {"cardHeader":"MenuSelectionItem_cardHeader__ZXXPi","imgBg":"MenuSelectionItem_imgBg__D9JSw","cardTitle":"MenuSelectionItem_cardTitle__a6Dp0"};